var OKMImageCompare = {
  isTouch: false,
  div: null,
  sep: null,
  img: null,

  onDown: function(e, imgId, isTouch)
    {
      e.preventDefault();
      this.isTouch = isTouch;
      
      this.div = document.getElementById( "okm-ic-handle-" + imgId );
      this.sep = document.getElementById( "okm-ic-separator-" + imgId );
      this.img = document.getElementById( "okm-ic-image-" + imgId );
    },

  onUp: function()
    {
      this.div = null;
      this.sep = null;
      this.img = null;
    },

  onMove: function(e)
    {
      event.preventDefault();
      if ( ( this.div != null ) && ( this.sep != null ) && ( this.img != null ) )
      {
        var cX = 0;
        if ( this.isTouch ) cX = event.touches[0].clientX;
        else cX = event.clientX;
        
        const rect = this.img.getBoundingClientRect();
        var pos = ( cX + window.scrollX );
        if ( pos < rect.left ) pos = rect.left;
        else if ( pos > rect.right ) pos = rect.right;
          
        this.div.style.left = (pos - rect.left) + 'px';
        this.sep.style.left = (pos - rect.left) + 'px';
        this.img.style.clipPath = 'inset(0 ' + ( rect.width - ( pos - rect.left ) ) + 'px 0 0)';
      }
    }
}

document.addEventListener( 'mouseup', function(){ OKMImageCompare.onUp(); }, true );
document.addEventListener( 'touchend', function(){ OKMImageCompare.onUp(); }, true );

document.addEventListener( 'mousemove', function(e){ OKMImageCompare.onMove( e ); }, true );
document.addEventListener( 'touchmove', function(e){ OKMImageCompare.onMove( e ); }, true );